import * as types from './historyActionTypes';

const initialState = {
    history: [],
    destroyHistory : false
};

const retrieveHistory = (state, action) => {
    const { key, actionName = action.action, entity, created_at, points, value } = action;
    return {
        ...state,
        history:[
            {
                historyId: key,
                action: actionName,
                entity,
                points,
                value,
                created_at
            },
            ...state.history
        ]
    };
}

const duplicateHistory = (state, action) => {
        return state;
} 

const destroyHistoryListeners = (state, action) => {
    return {
        ...state, 
        history: []
    };
}

export const history = (state = initialState, action) => {
    switch(action.type) {
        case types.RETRIEVE_HISTORY:    return retrieveHistory(state, action);
        case types.DUPLICATE_HISTORY:   return duplicateHistory(state, action);
        case types.DESTROY_HISTORY:     return destroyHistoryListeners(state, action);
        default: return state;
    }
}

export default history;


// WEBPACK FOOTER //
// ./src/components/History/historyReducers.js